import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

const Counter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <section className="section cta">
        <div className="bg-overlay"></div>
        <Container>
          <Row id="counter">
            {/* <Col lg={3}>
              <div className="text-center">
                <div className="counter-icon">
                  <i className="pe-7s-like"></i>
                </div>
                <h2 className="counter-count mt-4 text-white">
                  <CountUp start={0} end={0} duration={2} />
                  <span className="counter_value display-4" id="count1"></span>
                </h2>
                <h5 className="mt-3 text-uppercase f-13 text-light letter-spacing_2">
                  {t("counter.projectsLike")}
                </h5>
              </div>
            </Col> */}

            <Col lg={4}>
              <div className="text-center">
                {/* <div className="counter-icon">
                  <i className="pe-7s-smile"></i>
                </div> */}
                <h2 className="counter-count mt-4 text-white">
                  <CountUp start={0} end={3500} duration={2} />
                  <span className="counter_value display-4" id="count2"></span>
                </h2>
                <h5 className="mt-3 text-uppercase f-13 text-light letter-spacing_2">
                  {t("counter.happyClients")}
                </h5>
              </div>
            </Col>

            <Col lg={4}>
              <div className="text-center">
                {/* <div className="counter-icon">
                  <i className="pe-7s-anchor"></i>
                </div> */}
                <h2 className="counter-count mt-4 text-white">
                  <CountUp start={0} end={1000} duration={2.5} />
                  <span className="counter_value display-4" id="count3"></span>
                </h2>
                <h5 className="mt-3 text-uppercase f-13 text-light letter-spacing_2">
                  {t("counter.projectsCompleted")}
                </h5>
              </div>
            </Col>

            <Col lg={4}>
              <div className="text-center">
                {/* <div className="counter-icon">
                  <i className="pe-7s-user"></i>
                </div> */}
                <h2 className="counter-count mt-4 text-white">
                  <CountUp start={0} end={12} duration={2} />
                  <span className="counter_value display-4" id="count4"></span>
                </h2>
                <h5 className="mt-3 text-uppercase f-13 text-light letter-spacing_2">
                  {t("counter.employee")}
                </h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Counter;
